import { Text } from '@comicrelief/component-library';
import styled from 'styled-components';

import { useAppSelector } from '@/store/hooks';

const ErrorWrapper = styled.div<{ $addMargin?: boolean }>`
  text-align: center;
  ${props => props.$addMargin && `
    margin: 1rem 0;
  `}
`;

interface PaymentErrorTextProps {
  $addMargin?: boolean;
}

function PaymentErrorText({ $addMargin = false }: PaymentErrorTextProps) {
  const transactionState = useAppSelector(state => state.transaction);

  if (!transactionState?.errorMessage) {
    return null;
  }

  return (
    <ErrorWrapper $addMargin={$addMargin}>
      <Text color="red" weight="bold">
        {transactionState.errorMessage}
      </Text>
    </ErrorWrapper>
  );
}

export default PaymentErrorText;
